import backgroundColor from "./backgroundColor";

export {
  backgroundColor
};
